import { render, staticRenderFns } from "./ContributorsDetails.vue?vue&type=template&id=0c8a4278&"
import script from "./ContributorsDetails.vue?vue&type=script&lang=ts&"
export * from "./ContributorsDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports